module.exports = __webpack_public_path__ + "img/wx.a2d75ef6.jpg";